import React from 'react'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Icon from 'components/_new/ui/Icon/Icon'

import messages from './messages'
import s from './ArrivalDate.scss'


const ArrivalDate = ({ year = '', month }) => (
  <div className={s.container}>
    <Icon
      className={s.truckIcon}
      name="truck"
      color="brand"
    />
    <Box pl="8">
      <Text
        className={s.date}
        message={{ ...messages.arrives, values: { month, year } }}
        color="brand"
        size="14-24"
        html
      />
    </Box>
  </div>
)


export default ArrivalDate
